var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 16,
    rx: 2,
    fill: "url(#paint0_linear_32719_40752)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95992 3.92H6.62992L10.0599 9.18H10.0799V3.92H11.3399V11H9.73992L6.23992 5.57H6.21992V11H4.95992V3.92ZM13.7689 9.02C13.8089 9.38 13.9489 9.66 14.1889 9.86C14.4289 10.06 14.7189 10.16 15.0589 10.16C15.3589 10.16 15.6089 10.1 15.8089 9.98C16.0156 9.85333 16.1956 9.69667 16.3489 9.51L17.2089 10.16C16.9289 10.5067 16.6156 10.7533 16.2689 10.9C15.9222 11.0467 15.5589 11.12 15.1789 11.12C14.8189 11.12 14.4789 11.06 14.1589 10.94C13.8389 10.82 13.5622 10.65 13.3289 10.43C13.0956 10.21 12.9089 9.94667 12.7689 9.64C12.6356 9.32667 12.5689 8.98 12.5689 8.6C12.5689 8.22 12.6356 7.87667 12.7689 7.57C12.9089 7.25667 13.0956 6.99 13.3289 6.77C13.5622 6.55 13.8389 6.38 14.1589 6.26C14.4789 6.14 14.8189 6.08 15.1789 6.08C15.5122 6.08 15.8156 6.14 16.0889 6.26C16.3689 6.37333 16.6056 6.54 16.7989 6.76C16.9989 6.98 17.1522 7.25333 17.2589 7.58C17.3722 7.9 17.4289 8.27 17.4289 8.69V9.02H13.7689ZM16.2289 8.12C16.2222 7.76667 16.1122 7.49 15.8989 7.29C15.6856 7.08333 15.3889 6.98 15.0089 6.98C14.6489 6.98 14.3622 7.08333 14.1489 7.29C13.9422 7.49667 13.8156 7.77333 13.7689 8.12H16.2289ZM17.9011 6.2H19.2011L20.2411 9.56H20.2611L21.2311 6.2H22.5311L23.5711 9.56H23.5911L24.5911 6.2H25.8011L24.1711 11H22.9811L21.8411 7.72H21.8211L20.8111 11H19.5711L17.9011 6.2Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32719_40752",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#D8DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#C4A4EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/New.e1df273b7f4bed3fb236fe970dcaa0bb.svg";
export { ForwardRef as ReactComponent };